import React from "react";
import { Image } from "react-bootstrap";
// import Contact_Us_banner from "../../assets/Contact banner.svg";
import Contact_Us_banner from "../../assets/New_banner.svg";
import Contact_us_Breadcrumb from "../../assets/Contact_us_Breadcrumb.svg";
import Email_Icon from "../../assets/Email_Icon.svg";
import Mobile_Icon from "../../assets/Mobile_Icon.svg";
import Landline_Icon from "../../assets/Landline_Icon.svg";
import Location_Icon from "../../assets/Location_Icon.svg";
import Clock_Icon from "../../assets/Clock_Icon.svg";

const ContactUs = () => {
  return (
    <div className="about-us-container">
      {/* <Image src={Contact_us_Breadcrumb} />
      <Image src={Contact_Us_banner} /> */}
      {/* Breadcrumb */}
      <nav aria-label="breadcrumb" className="page-breadcrumb">
        <ol>
          <li>
            <li className="crumb-home">Home</li>
          </li>
          <li className="active" aria-current="page">
            Contact Us
          </li>
        </ol>
      </nav>

      {/* Banner */}
      <div className="page-banner">
        <Image src={Contact_Us_banner} alt="" className="page-banner-img" />
        <h1 className="page-banner-title">Contact Us</h1>
      </div>
      <div className="contact-us-content">
        <div className="contact-us-grid">
          {/* Left card: person details */}
          <div className="contact-card">
            <h2 className="contact-name">Rohit Dua</h2>
            <p className="contact-designation">
              Technology Lead, Project Monitoring Group (PMG)
            </p>
            <p className="contact-org">
              Secretariat to Monitoring Group, PMO
              <br />
              Government of India
            </p>

            <hr className="contact-divider" />

            <div className="contact-item">
              <img src={Email_Icon} alt="" className="contact-icon" />
              <div>
                <span className="contact-label">Email</span>
                <span className="contact-email">
                  pmg[at]investindia[dot]org[dot]in
                </span>
              </div>
            </div>

            <div className="contact-row">
              <div className="contact-item">
                <img src={Mobile_Icon} alt="" className="contact-icon" />
                <div>
                  <span className="contact-label">Mobile</span>
                  <span className="contact-value">+91 9923478514</span>
                </div>
              </div>

              <div className="contact-item">
                <img src={Landline_Icon} alt="" className="contact-icon" />
                <div>
                  <span className="contact-label">Landline</span>
                  <span className="contact-value">(011) 26773798</span>
                </div>
              </div>
            </div>
          </div>

          {/* Right card: office details */}
          <div className="contact-card contact-card-blue">
            <h2 className="contact-office-title">Office details</h2>

            <div className="contact-item">
              <img src={Location_Icon} alt="" className="contact-icon" />
              <div>
                <span className="contact-label">Address</span>
                <span className="contact-value">
                  GPOA 3, Netaji Nagar, New Delhi-110023
                </span>
              </div>
            </div>

            <hr className="contact-divider" />

            <div className="contact-item">
              <img src={Clock_Icon} alt="" className="contact-icon" />
              <div>
                <span className="contact-label">Office hours</span>
                <span className="contact-value">
                  Monday – Friday (10:00 AM – 6:00 PM)
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
